import timeNone from './time-none';

export default [...timeNone];